import { ReactNode } from 'react'

import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'

export const BackLink = ({ children }: { children: ReactNode }) => (
    <Box mt="space30" mb={['space10', 'space20']} gridColumn="1/13">
        {children}
    </Box>
)

export const PageHeading = ({ children }: { children: ReactNode }) => (
    <Box gridColumn="1/13" mb={['space30', 'space50']}>
        {children}
    </Box>
)

export const ItemWrapper = ({ children }: { children: ReactNode }) => (
    <Box
        gridColumn="1/13"
        display="grid"
        gridGap={['space30', 'space50']}
        pb="space90"
    >
        {children}
    </Box>
)

export const ItemDetails = ({ children }: { children: ReactNode }) => (
    <Flex
        gridColumn={['1/13', '1/13', '1/9']}
        flexDirection={['column', 'row']}
    >
        {children}
    </Flex>
)

export const ItemImage = ({ children }: { children: ReactNode }) => (
    <Flex
        maxWidth={['216px', '375px']}
        mr={[0, 'space50']}
        mb={['space30', 0]}
        alignSelf={['center', 'flex-start']}
    >
        {children}
    </Flex>
)

export const ItemContent = ({ children }: { children: ReactNode }) => (
    <Flex flexDirection="column" justifyContent="space-between">
        {children}
    </Flex>
)

export const ItemButtons = ({ children }: { children: ReactNode }) => (
    <Flex
        gridColumn={['1/13', '1/13', '9/13']}
        alignItems={['flex-end', 'center']}
        justifyContent="center"
    >
        {children}
    </Flex>
)
